"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { withProductHubs, type NavGroup, type NavLink } from "@/lib/nav-data";

const NavHubsContext = createContext<readonly NavLink[]>([]);

/**
 * Reicht die serverseitig geladenen Produkt-Hubs an Desktop- und Mobil-Navigation.
 * Header und MobileFloatingBar sind Client-Komponenten; so muss die Liste nicht
 * durch beide hindurchgereicht werden.
 */
const NavHubsProvider = ({ hubs, children }: { hubs: readonly NavLink[]; children: ReactNode }) => (
  <NavHubsContext.Provider value={hubs}>{children}</NavHubsContext.Provider>
);

/** Hauptnavigation inklusive "Wissen" › "Produkt Reviews" › Hubs. */
const useNavGroups = (): readonly NavGroup[] => {
  const hubs = useContext(NavHubsContext);
  return useMemo(() => withProductHubs(hubs), [hubs]);
};

export { NavHubsProvider, useNavGroups };
